import { AccessorsMutatorsDecorator } from '../../helpers';
import { TranslatableModel } from './translatable-model';
import { GeneralSettings } from './general-settings.model';
import { Country } from './country.model';
import { Subscription } from './subscription.model';
import { AddonSetting } from './addon-setting.model';

/**
 * @class Property
 * @property {number} id
 * @property {string} code
 * @property {string} name
 * @property {string} description
 * @property {string} status
 */
export class Property extends TranslatableModel {

    /**
     * @type {string[]}
     */
    static get translatableAttributes() {
        
        return [ 'name', 'description' ];
    }

    static get validationModel() {

        return {
            name: {
                label: 'PROPERTY_NAME_IN_ENGLISH',
                commonLabel: 'Property Name',
            },
            name_ar: {
                label: 'PROPERTY_NAME_IN_ARABIC',
                commonLabel: 'Property Name',
            },
            description: {
                label: 'DESCRIPTION_IN_ENGLISH',
                commonLabel: 'Description',
            },
            description_ar: {
                label: 'DESCRIPTION_IN_ARABIC',
                commonLabel: 'Description',
            },
            email: {
                label: 'EMAIL',
                messages: {
                    email: 'EMAIL_MUST_BE_IN_THE_FORMAT_EMAIL'
                }
            },
            user: {
                label: 'BUSINESS_OWNER'
            },
            commercial_registration_no: {
                label: 'COMMERCIAL_REGISTRATION_NO',
                commonLabel: 'Commercial Registration No.',
                messages: {
                    pattern: 'COMMERCIAL_REGISTRATION_NO_MUST_BE_NUMBERS_ONLY'
                }
            },
            district: {
                label: 'DISTRICT',
                commonLabel: 'District',
            },
            street: {
                label: 'STREET',
                commonLabel: 'Street',
            },
            building_number: {
                label: 'BUILDING_NUMBER',
                commonLabel: 'Building Number',
                messages: {
                    pattern: 'BUILDING_NUMBER_MUST_BE_NUMBERS_ONLY'
                }
            },
            postal_code: {
                label: 'POSTAL_CODE',
                commonLabel: 'Postal Code',
            }
        };
    }

    getRoomNumber() {

        if (this.accommodation_types) {

            let number = 0;

            for (const type of this.accommodation_types) {

                if (type.room_numbers_count) {

                    number += parseInt(type.room_numbers_count);
                }
            }

            return number;
        }

        return 0;
    }

    setCountry(value) {

        return value && (value instanceof Country ? value : new Country(value));
    }

    /**
     * @param {Object|Setting} value
     * @returns {Property}
     */
    setGeneralSettings(value) {

        return value && (value instanceof GeneralSettings ? value : new GeneralSettings(value));
    }

    /**
     * @param {Object|Subscription} value
     * @returns {Subscription}
     */
    setActiveSubscription(value) {

        if (!value) {

            return value;
        }

        return value instanceof Subscription ? value : new Subscription(value);
    }

    /**
     * Check if property has an addon in active subscription
     *
     * @param {number} addonClass
     *
     * @returns {boolean}
     */
    hasAddonInSubscription(addonClass) {

        return this.activeSubscription && this.activeSubscription.addons && this.activeSubscription.addons.findIndex(addon => addon.class === addonClass) !== -1;
    }

    /**
     * Check if property has a cash drawer addon in active subscription
     *
     * @returns {boolean}
     */
    hasCashDrawerAddon()
    {
        return this.hasAddonInSubscription(AddonSetting.CLASS_CASH_DRAWER);
    }
}

AccessorsMutatorsDecorator(
    'id',
    'code',
    ...Property.translatableAttributesWithLanguageAliases,
    'status',
    'created_at',
    'type',
    'class',
    'contact_name',
    'email',
    'website',
    'phone_code',
    'phone_number',
    'country',
    'city',
    'address',
    'lat',
    'lng',
    'type_id',
    'class_id',
    'country_id',
    'city_id',
    'logo',
    'images',
    'user',
    'user_id',
    'unique_id',
    'general_settings',
    'invoicing',
    'policy',
    'deleted_at',
    'user_name',
    'name_old',
    'name_old_ar',
    'statuses',
    'subscriptions',
    'activeSubscription',
    'active_subscriptions_count',
    'not_cancelled_subscriptions_count',
    'accommodation_types',
    'opened_cash_drawers_count',
    'ntmp_integration_addon',
    'shomoos_integration_addon',
    'channel_manager_addon',
    'balady_integration_addon',
    'zatca_integration_addon',
    'availability_to',
    'distribution_default_currency',
    'online_reservations',
    'commercial_registration_no',
    'district',
    'street',
    'building_number',
    'postal_code',
)(Property);



// WEBPACK FOOTER //
// ./src/pms-api/models/property.model.js